const phoneMask = (value: any) => {
  if (!value) return "";
  const digits = String(value).replace(/\D/g, "");

  // Celular: DDD (2) + 9 dígitos => (XX) 9XXXX-XXXX
  if (digits.length === 11) {
    return digits.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }

  // Fixo: DDD (2) + 8 dígitos => (XX) XXXX-XXXX
  if (digits.length === 10) {
    return digits.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }

  // Fallback para quantidades de dígitos inesperadas
  return digits
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d)(\d{4})$/, "$1-$2");
};

export default phoneMask;
